import { render, staticRenderFns } from "./shortcodeBlogPost.vue?vue&type=template&id=f8ec6308&"
import script from "./shortcodeBlogPost.vue?vue&type=script&lang=js&"
export * from "./shortcodeBlogPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports